import { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { getMergeExportDownloadUrl } from 'entities/Files/api';
import { showErrorNotification } from 'shared/helpers/showErrorNotification';
import { Loader } from 'shared/ui/Loader';
import { Routes } from 'app/config/routes/consts';

export const MergeExport: FC = () => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();

	useQuery({
		queryKey: ['get/merge-export/download', id],
		queryFn: () => getMergeExportDownloadUrl(id as string),
		enabled: !!id,
		onSuccess: (res) => {
			const url = res.data?.url;
			if (url) {
				const a = document.createElement('a');
				a.href = url;
				a.download = '';
				document.body.appendChild(a);
				a.click();
				a.remove();
			}
			navigate(Routes.filesRoot);
		},
		onError: (err) => {
			showErrorNotification(err as AxiosError);
			navigate(Routes.filesRoot);
		},
	});

	return <Loader type="fullpage" />;
};
